var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { sidebarItemsConfig } from '@features/home/constants';
import { useLocation } from 'react-router-dom';
import { SidebarItem } from './sidebar-item.component';
import { SidebarListItem } from './sidebar-list-item.component';
import { SidebarList } from './sidebar-list.component';
export var Sidebar = function () {
    var pathname = useLocation().pathname;
    return (_jsx("div", __assign({ className: "flex h-full w-[248px] min-w-[248px] flex-col" }, { children: sidebarItemsConfig.items.map(function (item) {
            return item.childrens ? (_createElement(SidebarList, __assign({}, item.params, { key: item.params.id, currentPath: pathname, path: "".concat(sidebarItemsConfig.basePath, "/").concat(item.params.path) }),
                _jsx(_Fragment, { children: item.childrens.map(function (children) { return (_createElement(SidebarListItem, __assign({}, children, { key: children.id, currentPath: pathname, path: "".concat(sidebarItemsConfig.basePath, "/").concat(item.params.path, "/").concat(children.path) }))); }) }))) : (_createElement(SidebarItem, __assign({}, item.params, { key: item.params.id, currentPath: pathname, path: "".concat(sidebarItemsConfig.basePath, "/").concat(item.params.path) })));
        }) })));
};
